import { type FC } from "react";
import { Stacker } from "~/common/components/Stacker/Stacker";
import Modal from "../../../../common/components/Modal";
import { IconType } from "../../../../common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/components/Button/Button";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

interface Props {
  onCancel: () => void;
  onOverride: () => void;
  onAdd: () => void;
}

const CartContainsItemsModal: FC<Props> = ({ onCancel, onOverride, onAdd }) => {
  const { t } = useTranslation();
  const webservicesDisabled = window.SCHA.config.disableAllWS;
  return (
    <Modal
      onClose={onCancel}
      title={t("orderDetailsPage.explanation.header")}
      footerChildren={
        <div className="d-flex flex-justify-between flex-align-center w-100">
          <Button variant={"text"} onClick={onCancel}>
            {t("bulkUpload.buttons.cancel")}
          </Button>
          <Stacker direction={"row"} gap={8}>
            <Button
              color={"secondary"}
              onClick={onOverride}
              startIcon={<DefaultButtonIcon type={IconType.Cart} />}
              disabled={webservicesDisabled}
            >
              {t("bulkUpload.buttons.override")}
            </Button>
            <Button
              onClick={onAdd}
              startIcon={<DefaultButtonIcon type={IconType.Cart} />}
              disabled={webservicesDisabled}
            >
              {t("bulkUpload.buttons.add")}
            </Button>
          </Stacker>
        </div>
      }
    >
      <ul>
        <li>{t("orderDetailsPage.explanation.add")}</li>
        <li>{t("orderDetailsPage.explanation.override")}</li>
      </ul>
    </Modal>
  );
};

export default CartContainsItemsModal;
